import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';

class Faq extends React.Component {
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <Link to={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></Link>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                </div>
                <div className="faq-content">
                    <Link to={'/ttbhelp/Faqdetails/booking-and-ticking'}>Booking and Ticketing</Link>
                    <Link to={'/ttbhelp/Faqdetails/refunds-and-cancellations'}>Refunds and Cancellations</Link>
                    <Link to={'/ttbhelp/Faqdetails/pnr-train-status'}>PNR and Train Status</Link>
                    <Link to={'/ttbhelp/Faqdetails/payment'}>Payment and Charges</Link>
                    <Link to={'/ttbhelp/Faqdetails/account'}>Account and Profile Management</Link>
                    <Link to={'/ttbhelp/Faqdetails/meal'}>Meal Preferences and Onboard Services</Link>
                    <Link to={'/ttbhelp/Faqdetails/technical'}>Technical Issues and Troubleshooting</Link>
                    <Link to={'/ttbhelp/Faqdetails/traininfo'}>Train Information and Travel Guidance</Link>
                    <Link to={'/ttbhelp/Faqdetails/irctc'}>IRCTC Related Queries</Link>
                    <Link to={'/ttbhelp/Faqdetails/miscellaneous'}>Miscellaneous</Link>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(Faq);

